import { Helmet } from "react-helmet-async";
import PageShell from "@/components/PageShell";
import Faq from "@/components/Faq";

const FaqPage = () => (
  <PageShell>
    <Helmet>
      <title>FAQ | Zentra</title>
      <meta name="description" content="Everyday Protein. Powered by Microgreens. Zentra protein bars made with horse gram microgreens we grow ourselves. Order online from Coimbatore." />
    </Helmet>
    <Faq />
  </PageShell>
);

export default FaqPage;
